import { render, staticRenderFns } from "./ActiveArticle.vue?vue&type=template&id=d432f75a&scoped=true&"
import script from "./ActiveArticle.vue?vue&type=script&lang=js&"
export * from "./ActiveArticle.vue?vue&type=script&lang=js&"
import style0 from "./ActiveArticle.vue?vue&type=style&index=0&id=d432f75a&prod&lang=scss&scoped=true&"
import style1 from "./ActiveArticle.vue?vue&type=style&index=1&id=d432f75a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d432f75a",
  null
  
)

export default component.exports